/* LEHUA · Mobile Menu Drawer
   - Intercepta click no botão hamburger original (Horizon) no mobile e abre o drawer Lehua
   - Slide-in nav entre painéis (root → submenu)
   - ESC + overlay click fecham */

(function () {
  'use strict';

  let drawer = null;
  let rootPanel = null;
  let activeChild = null;
  let triggerEl = null;

  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    // Reverte o ícone do header (X -> hambúrguer): fecha o <details> nativo do menu.
    // No iOS o <details> abre no toque apesar do preventDefault; aqui garantimos o reset.
    const menuSummary = triggerEl || document.querySelector('.header__icon--menu, summary[aria-label="Menu"]');
    const menuDetails = menuSummary && menuSummary.closest('details');
    if (menuDetails) menuDetails.open = false;
    setTimeout(() => {
      // Reset to root after close
      if (activeChild) {
        activeChild.classList.remove('is-active');
        activeChild = null;
      }
      rootPanel && rootPanel.classList.remove('is-pushed');
      drawer.querySelectorAll('[aria-expanded="true"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
    }, 320);
  }

  function showPanel(name) {
    const panel = drawer.querySelector('[data-lehua-mm-panel="' + name + '"]');
    if (!panel) return;
    if (activeChild) activeChild.classList.remove('is-active');
    panel.classList.add('is-active');
    activeChild = panel;
    if (rootPanel) rootPanel.classList.add('is-pushed');
  }

  function showRoot() {
    if (activeChild) activeChild.classList.remove('is-active');
    activeChild = null;
    if (rootPanel) rootPanel.classList.remove('is-pushed');
    drawer.querySelectorAll('[aria-expanded="true"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  function bindInternal() {
    if (!drawer) return;
    drawer.querySelectorAll('[data-lehua-mm-close]').forEach(el => el.addEventListener('click', close));
    drawer.querySelectorAll('[data-lehua-mm-back]').forEach(el => el.addEventListener('click', showRoot));
    drawer.querySelectorAll('[data-lehua-mm-open]').forEach(el => {
      el.addEventListener('click', () => {
        el.setAttribute('aria-expanded', 'true');
        showPanel(el.dataset.lehuaMmOpen);
      });
    });
  }

  function interceptHamburger() {
    // Horizon native: <details><summary class="header__icon--menu">...
    document.addEventListener('click', e => {
      if (!isMobile()) return;
      const summary = e.target.closest('.header__icon--menu, summary[aria-label="Menu"]');
      if (!summary) return;
      // Prevent <details> from opening
      e.preventDefault();
      e.stopPropagation();
      // Close native details if it was already open
      const details = summary.closest('details');
      if (details && details.open) details.open = false;
      triggerEl = summary;
      open();
    }, true); // capture phase to run BEFORE Horizon
  }

  function init() {
    drawer = document.getElementById('lehua-mobile-menu');
    if (!drawer) return;
    rootPanel = drawer.querySelector('[data-lehua-mm-panel="root"]');
    bindInternal();
    interceptHamburger();

    // iOS: impede o <details> nativo do menu de ficar aberto no mobile.
    // No toque do iPhone ele abre apesar do preventDefault e prende o ícone no X.
    // Como o drawer Lehua tem seu próprio X, o hambúrguer nunca precisa virar X.
    document.querySelectorAll('.header__icon--menu, summary[aria-label="Menu"]').forEach(summary => {
      const det = summary.closest('details');
      if (!det) return;
      // 1) evento toggle (rápido)
      det.addEventListener('toggle', function () {
        if (isMobile() && det.open) det.open = false;
      });
      // 2) MutationObserver — à prova dos quirks do iOS: remove o atributo open na hora
      try {
        const obs = new MutationObserver(function () {
          if (isMobile() && det.hasAttribute('open')) det.removeAttribute('open');
        });
        obs.observe(det, { attributes: true, attributeFilter: ['open'] });
      } catch (e) { /* noop */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
